module.exports = __webpack_public_path__ + "img/L_320_326.f7851f9b.png";